import React from "react"
import { Button, Card, CardBody, Input, Label, FormGroup } from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"

const ReturnRequestListComponent = ({
  data,
  loading,
  onPageClick,
  onChangeRowNumber,
  selectedIds,
  onCheckboxChange,
  onSelectAll,
  onApprove,
  onReject,
  adminNote,
  onAdminNoteChange,
  showActions = true,
  showAdminNote = true,
}) => {
  const pendingItems =
    data?.data?.filter(item => item.status === "Pending") || []
  const allPendingSelected =
    pendingItems.length > 0 &&
    pendingItems.every(item => selectedIds.includes(item.id))

  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <CustomHeaderTitle
            loading={loading}
            rowCount={false}
            onChangeRowNumber={onChangeRowNumber}
            lgColumn={4}
          />
          {showActions && (
            <div className="d-flex gap-2">
              <Button
                color="success"
                onClick={onApprove}
                disabled={selectedIds.length === 0 || loading}
              >
                Approve Selected
              </Button>
              <Button
                color="danger"
                onClick={onReject}
                disabled={selectedIds.length === 0 || loading}
              >
                Reject Selected
              </Button>
            </div>
          )}
        </div>

        {showAdminNote && (
          <FormGroup className="mb-3">
            <Label>Admin Note (optional)</Label>
            <Input
              type="textarea"
              rows={2}
              value={adminNote}
              onChange={e => onAdminNoteChange(e.target.value)}
              placeholder="Add a note for approve/reject actions"
            />
          </FormGroup>
        )}

        <GeneralTables
          data={data?.data}
          loading={loading}
          parentCheckbox={showActions}
          onParentCheckChange={showActions ? onSelectAll : undefined}
          headers={[
            "SN",
            "PROVIDER",
            "PROVINCE",
            "ITEM",
            "FUND CODE",
            "SHIPMENT",
            "WAYBILL",
            "COMMODITY CLASS.",
            "DISTRIBUTED",
            "CONSUMED",
            "RE-ALLOCATION QTY",
            "STATUS",
            "REQUESTED",
            "APPROVED/REJECTED",
            ...(showActions ? ["SELECT"] : []),
          ]}
          pagination={{ meta: data?.meta, onPageClick: onPageClick }}
          renderItem={(item, index) => {
            const isChecked = selectedIds.includes(item.id)
            const isPending = item.status === "Pending"

            return (
              <tr key={item.id}>
                <th scope="row">{data?.meta?.from + index}</th>
                <td>{item.provider?.title || "-"}</td>
                <td>{item.province?.province || "-"}</td>
                <td>{item.item?.ip_item_description || "-"}</td>
                <td>{item.fund_code?.code || "-"}</td>
                <td>{item.shipment?.name || "-"}</td>
                <td>{item.waybill_number || "-"}</td>
                <td>{item.commodity_classification?.name || "-"}</td>
                <td>{item.distributed_quantity}</td>
                <td>{item.province_consumed_quantity}</td>
                <td>{item.return_quantity}</td>
                <td>
                  <span
                    className={`badge ${
                      item.status === "Approved"
                        ? "badge-soft-success"
                        : item.status === "Rejected"
                        ? "badge-soft-danger"
                        : "badge-soft-warning"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>
                <td>
                  {item.created_at
                    ? new Date(item.created_at).toLocaleDateString()
                    : "-"}
                </td>
                <td>
                  {item.approved_at
                    ? new Date(item.approved_at).toLocaleDateString()
                    : item.rejected_at
                    ? new Date(item.rejected_at).toLocaleDateString()
                    : "-"}
                </td>
                {showActions && (
                  <td>
                    {isPending && (
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={e =>
                          onCheckboxChange(item.id, e.target.checked)
                        }
                      />
                    )}
                  </td>
                )}
              </tr>
            )
          }}
        />
      </CardBody>
    </Card>
  )
}

export default ReturnRequestListComponent
